import "../vars_spectrum-darkest.css";
import $ksyDR$vars_spectrumdarkest_cssmjs from "../vars_spectrum-darkest_css.mjs";
import "../vars_spectrum-global.css";
import $ksyDR$vars_spectrumglobal_cssmjs from "../vars_spectrum-global_css.mjs";
import "../vars_spectrum-large.css";
import $ksyDR$vars_spectrumlarge_cssmjs from "../vars_spectrum-large_css.mjs";
import "../vars_spectrum-light.css";
import $ksyDR$vars_spectrumlight_cssmjs from "../vars_spectrum-light_css.mjs";
import "../vars_spectrum-medium.css";
import $ksyDR$vars_spectrummedium_cssmjs from "../vars_spectrum-medium_css.mjs";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />





let $cdf1a36dc96a08db$export$164de7ab8df77ef0 = {
    global: ($parcel$interopDefault($ksyDR$vars_spectrumglobal_cssmjs)),
    light: ($parcel$interopDefault($ksyDR$vars_spectrumlight_cssmjs)),
    dark: (0, ($parcel$interopDefault($ksyDR$vars_spectrumdarkest_cssmjs))),
    medium: ($parcel$interopDefault($ksyDR$vars_spectrummedium_cssmjs)),
    large: ($parcel$interopDefault($ksyDR$vars_spectrumlarge_cssmjs))
};


export {$cdf1a36dc96a08db$export$164de7ab8df77ef0 as defaultTheme};
//# sourceMappingURL=defaultTheme.mjs.map
